export const home = {
  // Hero Section
  hero: {
    title: 'VİZYONUN\nFORMA DÖNÜŞTÜĞÜ YER',
    subtitle: 'KURULUŞUNDAN BU YANA USTALIKLA ŞEKİLLENEN MÜKEMMELLİK',
  },

  // Welcome Statement
  welcome: {
    text: 'LUCENDO dünyasına hoş geldiniz — vizyonun forma dönüştüğü, kalitenin kimliğe dönüştüğü yer. Evimiz; inovasyonun, yaratıcılığın ve titiz üretimin buluşma noktasıdır. Fikirler; uzmanlık, teknoloji ve rafine estetik aracılığıyla olağanüstü ürünlere dönüşür. Konseptten tamamlanmaya kadar her adım, hassasiyet ve özenle yönlendirilir.',
  },

  // Brand Pillars
  pillars: {
    whoWeAre: {
      title: 'BİZ KİMİZ',
      intro: 'LUCENDO’da lüks bir vaat değil — bir standarttır.',
      paragraph1: 'Hassasiyet, ustalık ve kaliteden ödün vermeyen bir anlayışla hareket eden bir markayız. Modern zarafeti ve zamansız değerleri derinlemesine kavrayan bir bakış açısıyla doğan Lucendo; güven veren, günlük deneyimleri yükselten ve rafine zevki yansıtan ürünler yaratmak için var.',
      paragraph2: 'Dokunduğumuz her detay bilinçlidir. Yarattığımız her ürün felsefemizi taşır: aşırılıksız mükemmeliyet, tavizsiz sofistike duruş ve özgünlüğe dayanan bir güzellik anlayışı.',
    },
    vision: {
      title: 'VİZYON',
      paragraph1: 'Mükemmeliyet, dürüstlük ve inovasyonla tanınan, küresel ölçekte saygı gören bir lüks marka olmak.',
      paragraph2: 'LUCENDO, ayrıcalığı önemseyen markalar ve müşteriler için premium kalitenin erişilebilir olduğu bir gelecek öngörür. Sorumluluk, yaratıcılık ve amaç doğrultusunda lüksün geleceğini şekillendirirken; özel marka ve üretim standartlarında yeni ölçütler belirlemeyi hedefler.',
    },
    mission: {
      title: 'MİSYON',
      paragraph1: 'Misyonumuz; zarafet, güvenilirlik ve performansı bünyesinde barındıran üstün ürünler sunmaktır.',
      paragraph2: 'Şunlara bağlıyız:',
      commitments: [
        'En yüksek uluslararası kalite standartlarını karşılayan ürünler üretmek',
        'Güvene ve şeffaflığa dayalı uzun vadeli iş ortaklıkları kurmak',
        'Ustalığa ve detaya saygı duyarak sürekli inovasyon sağlamak',
        'Estetiğin ötesine geçen, gerçek değer sunmak',
      ],
      closing: 'LUCENDO’da başarı yalnızca büyüme ile değil, bıraktığımız kalıcı iz ile ölçülür.',
    },
  },

  // Closing Statement
  closing: {
    quote: '"LUCENDO’da başarı yalnızca büyüme ile değil, bıraktığımız kalıcı iz ile ölçülür."',
  },
};